// src/screens/VuelosGuyanaScreen.jsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import VuelosGuyanaFlow from './vuelosGuyana/VuelosGuyanaFlow';
import VuelosGestorPropio from './vuelosGuyana/VuelosGestorPropio';
import TarjetaResenasClientes from '../components/TarjetaResenasClientes';

export default function VuelosGuyanaScreen({ onBack }) {
  const { user } = useAuth();

  return (
    <div className="page">
      <VuelosGestorPropio uid={user?.uid} />
      <TarjetaResenasClientes destino="/?tab=nuestros_clientes" />
      <VuelosGuyanaFlow uid={user?.uid} referredBy={user?.referred_by} onBack={onBack} origen="autenticado" />
    </div>
  );
}
